import { useRouter } from 'next/router'
// @mui
import { styled } from '@mui/material/styles'
import { Stack, Button, Chip, Divider, Typography, Link } from '@mui/material'
// utils
import { fCurrency } from '@/utils/formatNumber'
// @types
import { Merchandise } from '@/types/merchandise'
// components
import Markdown from '@/components/Markdown'
import { PATH_PAGE } from '@/routes/paths'
import NextLink from 'next/link'

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  height: '100%',
  padding: `${theme.spacing(3)} 0`,
  [theme.breakpoints.up(900)]: {
    padding: theme.spacing(5, 8),
    paddingRight: 0,
  },
}))

const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
`

type Props = {
  product: Merchandise
  callToActionLink: {
    title: string
    link: string
  } | null
}

export default function ProductDetailsSummary({ product, callToActionLink, ...other }: Props) {
  const { title, description, price, tags } = product

  const onSubmit = async () => {
    try {
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <RootStyle {...other}>
      <Stack spacing={1} direction="row" sx={{ mb: 3 }}>
        {tags.map((tag) => (
          <NextLink key={tag.id} href={`${PATH_PAGE.products}?tags=${tag.id}_${tag.name}`}>
            <StyledLink href={`${PATH_PAGE.products}?tags=${tag.id}_${tag.name}`}>
              <Chip label={tag.name} />
            </StyledLink>
          </NextLink>
        ))}
      </Stack>

      <Typography variant="h5" paragraph sx={{ mb: 3 }}>
        {title}
      </Typography>

      <Divider sx={{ borderStyle: 'dashed' }} />

      <Typography
        sx={{
          my: 3,
          height: {
            md: '50%',
            xs: '220px',
          },
          overflowY: 'auto',
        }}
      >
        <Markdown children={description || ''} />
      </Typography>

      {price && (
        <Typography variant="h4" sx={{ mb: 3 }}>
          &nbsp;{fCurrency(price)}
        </Typography>
      )}

      <Divider sx={{ borderStyle: 'dashed' }} />

      <Button
        fullWidth
        size="large"
        variant="contained"
        onClick={
          callToActionLink
            ? () => {
                window.open(callToActionLink.link, '_blank')
              }
            : onSubmit
        }
        sx={{ whiteSpace: 'nowrap', mt: 3 }}
      >
        {callToActionLink ? callToActionLink.title : 'Buy Now'}
      </Button>
    </RootStyle>
  )
}
